export default __webpack_public_path__ + "static/reports-presentation_kz-f5782cd36d4f143e7ea71642b626d878.webp";